import { Component } from '@angular/core';

import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'app-file-icon',
  template: `
    <svg
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.66668 1.89118V5.33329C9.66668 5.8 9.66668 6.03336 9.7575 6.21162C9.8374 6.36842 9.96488 6.4959 10.1217 6.5758C10.2999 6.66663 10.5333 6.66663 11 6.66663H14.4421M14.6667 8.32348V14.3333C14.6667 15.7334 14.6667 16.4335 14.3942 16.9683C14.1545 17.4387 13.7721 17.8211 13.3017 18.0608C12.7669 18.3333 12.0668 18.3333 10.6667 18.3333H5.33334C3.93321 18.3333 3.23315 18.3333 2.69837 18.0608C2.22796 17.8211 1.84551 17.4387 1.60583 16.9683C1.33334 16.4335 1.33334 15.7334 1.33334 14.3333V5.66663C1.33334 4.26649 1.33334 3.56643 1.60583 3.03165C1.84551 2.56124 2.22796 2.17879 2.69837 1.93911C3.23315 1.66663 3.93321 1.66663 5.33334 1.66663H8.00982C8.6213 1.66663 8.92704 1.66663 9.21476 1.7357C9.46985 1.79694 9.71371 1.89795 9.93739 2.03503C10.1897 2.18963 10.4059 2.40582 10.8382 2.8382L13.4951 5.49505C13.9275 5.92743 14.1437 6.14362 14.2983 6.39591C14.4353 6.61959 14.5364 6.86346 14.5976 7.11855C14.6667 7.40627 14.6667 7.712 14.6667 8.32348Z"
        stroke="#94A3B8"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  `,
})
export class FileIcon extends BaseIconComponent {}
